"use client";

import { ScrollRevealText } from "@/components/ui/scroll-reveal-text";
import { lg, useMediaMinWidthBeforePaint } from "@/hooks/use-media-min-width";

interface CareersHeroTitleProps {
  line1: string;
  line2: string;
}

/**
 * Careers hero title — one line on desktop, two lines on smaller screens.
 *
 * A single ScrollRevealText holds the copy so the H1 text is in the DOM once
 * (crawlers and extractors used to read it three times). Server and first
 * client render agree on the desktop copy; the before-paint media hook swaps
 * in the line break for smaller viewports with no hydration mismatch.
 */
export function CareersHeroTitle({ line1, line2 }: CareersHeroTitleProps) {
  const isDesktop = useMediaMinWidthBeforePaint(lg);

  return (
    <ScrollRevealText variant="dark">
      {isDesktop ? (
        `${line1} ${line2}`
      ) : (
        <>
          {line1}
          <br />
          {line2}
        </>
      )}
    </ScrollRevealText>
  );
}
